import React from 'react'

import "../../../assets/js/TypeEffect.js"
import Profilephoto from "../../../assets/images/photos/Profile.png"

const Quotes = () => {
    return (
        <div className="content quote">


            <div className="title">
                <span >Quote</span>
            </div>


            <div className="row">
                <div className="col col-d-12 col-t-12 col-m-12 border-line-v">
                    <div className="revs-item">
                        <div className="text">
                            <div className="typing-title typewrite" data-period="10000"
                                data-type='["When something is important enough, you do it even if the odds are not in your favor.",
                            "Failure is an option here. If things are not failing, you are not innovating enough.",
                            "Some people don’t like change, but you need to embrace change if the alternative is disaster.",
                            "The path to the CEO’s office should not be through the CFO’s office, and it should not be through the marketing department. It needs to be through engineering and design.",
                            "Persistence is very important. You should not give up unless you are forced to give up.",
                             "I think it’s very important to have a feedback loop, where you’re constantly thinking about what you’ve done and how you could be doing it better.",
                             "It’s OK to have your eggs in one basket as long as you control what happens to that basket.",
                             "I don’t think it’s a good idea to plan to sell a company.",
                             "It is a mistake to hire huge numbers of people to get a complicated job done. Numbers will never compensate for talent in getting the right answer (two people who don’t know something are no better than one), will tend to slow down progress, and will make the task incredibly expensive.",
                             "People work better when they know what the goal is and why. It is important that people look forward to coming to work in the morning and enjoy working."]'>
                                <span className="wrap"></span>
                            </div>
                        </div>
                        <div className="user">
                            <div className="img">
                                <img src={Profilephoto} alt="Piyush Talele" />
                            </div>
                            <div className="info">
                                <div className="name">Piyush Talele</div>
                                <div className="company">Full Stack Developer</div>
                            </div>
                            <div className="clear"></div>
                        </div>
                    </div>
                </div>
                <div className="clear"></div>
            </div>

        </div>
    );
}

export default Quotes;